import script from "./BuyGoods.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyGoods.vue?vue&type=script&setup=true&lang=js"

import "./BuyGoods.vue?vue&type=style&index=0&id=0f48af5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f48af5f"]])

export default __exports__